export default {
  addresses: [],
  address: undefined,
};
